<template>
    <div class="card" v-bind="$attrs">
        <div :class="headerClasses" :data-target="'#'+id" data-toggle="collapse">
            <slot name="header"></slot>
        </div>
        <div :id="id" :aria-expanded="isExpanded" :class="'collapse' + (isExpanded ? ' show' : '')">
            <div class="card-body">
                <slot name="body"></slot>
            </div>
            <div class="card-footer text-right" v-if="displayFooter">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
  import UniqueIdentifierFactory from "@/utilities/providers/UniqueIdentifierFactory";

  export default {
        data() {
            return {
                id: ''
            }
        },
        props: {
            // Optional CSS classes that get appended to the default card-header collapsed classes
            cardHeaderClass: {
                type: String,
                required: false,
                default: 'bg-primary text-white'
            },
            // Indicates if the footer should be displayed
            displayFooter: {
                type: Boolean,
                required: false,
                default: true
            },
            isExpanded: {
              type: Boolean,
              required: false,
              default: false
            }
        },

        computed: {
            headerClasses() {
                return 'card-header ' + this.cardHeaderClass + (this.isExpanded ? '' : ' collapsed')
            }
        },

        mounted() {
            this.id = 'card-' + UniqueIdentifierFactory.Create()
        }
    }
</script>

<style scoped>
    .card-header:hover {
        cursor: pointer;
        opacity: 0.9;
    }

    .card-header:first-child::before {
        content: "\f0d7";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        padding-right: 5px;
    }

    .card-header.collapsed:first-child::before {
        content: "\f0da";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        padding-right: 5px;
    }
</style>
